import React, { useEffect, useRef, useState } from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { format } from 'date-fns';
import './App.css';

const apiUrl = process.env.REACT_APP_API_URL;

const formatDateWithOrdinal = (date) => {
  const day = date.getDate();
  const suffix = ['th', 'st', 'nd', 'rd'][(day % 10) - 1] || 'th';
  return format(date, `MMMM d'${suffix}', yyyy`);
};

function App() {
  const container = useRef();
  const [selectedDate, setSelectedDate] = useState(null);
  const [predictedPrice, setPredictedPrice] = useState(null);
  const [actualPrice, setActualPrice] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (container.current.querySelector('iframe')) {
      return;
    }

    const script = document.createElement('script');
    script.src =
      'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = `
    {
      "width": "100%",
      "height": "100%",
      "autosize": true,
      "symbol": "BINANCE:BTCUSD",
      "interval": "D",
      "timezone": "Etc/UTC",
      "theme": "dark",
      "style": "1",
      "locale": "en",
      "allow_symbol_change": true,
      "calendar": false,
      "support_host": "https://www.tradingview.com",
      "container_id": "tradingview-widget"
    }`;

    container.current.appendChild(script);

    const adjustIframeSize = () => {
      const iframe = container.current.querySelector('iframe');
      if (iframe) {
        iframe.style.height = '100%';
        iframe.style.width = '100%';
      }
    };

    window.addEventListener('resize', adjustIframeSize);
    setTimeout(adjustIframeSize, 1000);

    return () => window.removeEventListener('resize', adjustIframeSize);
  }, []);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    predictPrice(date);
  };

  const predictPrice = async (date) => {
    try {
      const formattedDate = format(date, 'yyyy-MM-dd');
      const response = await fetch(`${apiUrl}/api/predict`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ date: formattedDate }),
      });
  
      if (!response.ok) {
        throw new Error('Failed to fetch prediction');
      }
  
      const data = await response.json();
      setPredictedPrice(data.predicted_price);
      setActualPrice(data.actual_price);
      setError(null);
    } catch (error) {
      console.error('Error:', error);
      setError('Failed to fetch prediction');
      setPredictedPrice(null);
      setActualPrice(null);
    }
  };

  return (
    <div className='app-container'>
      <div className='left-panel'>
        <div className='content'>
          <h2 className='title'>Pick a date for predicting Bitcoin price</h2>
          <DayPicker
            mode='single'
            selected={selectedDate}
            onSelect={handleDateChange}
          />
          {selectedDate && predictedPrice !== null && (
            <div className='prediction'>
              <p>
                Predicted price for{' '}
                <strong>
                  {selectedDate && formatDateWithOrdinal(selectedDate)}
                </strong>
                :<span className='price'> ${predictedPrice.toFixed(2)}</span>
              </p>
              {actualPrice && (
                <p>
                  Actual price:
                  <span className='price'> ${actualPrice.toFixed(2)}</span>
                </p>
              )}
              {error && <p className='error'>{error}</p>}
            </div>
          )}
        </div>
      </div>
      <div className='tradingview-widget-container' ref={container}></div>
    </div>
  );
}

export default App;
